import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { format } from "date-fns";

const typeLabel = {
  service_purchase: "Service reward",
  referral_bonus: "Referral bonus",
  voucher_redemption: "Voucher redeemed",
  cash_redemption_hold: "Cash payout hold",
  cash_redemption_refund: "Payout refund",
  cash_redemption_paid: "Cash payout",
};

export default function PointsHistory() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/ledger/my").then(r => setRows(r.data)); }, []);
  return (
    <div className="velo-card p-6 lg:p-8">
      <h2 className="text-xl text-white font-medium mb-1">Points history</h2>
      <p className="text-xs text-slate-500 uppercase tracking-wider mb-6">Append-only ledger</p>
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.id} data-testid={`ledger-row-${r.id}`} className="flex items-center justify-between py-3 border-b border-white/5">
            <div>
              <div className="text-sm text-white">{typeLabel[r.type] || r.type}</div>
              <div className="text-xs text-slate-500 mt-0.5">{r.reference_label || ""} · {format(new Date(r.created_at), "dd MMM yyyy, HH:mm")}</div>
            </div>
            <div className={`font-mono text-sm ${r.points >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
              {r.points >= 0 ? "+" : ""}{r.points}
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="text-slate-500 text-center py-8 text-sm">No transactions yet</div>}
      </div>
    </div>
  );
}
